import Navigation from "@/components/Navigation";
import BeforeAfterSlider from "@/components/BeforeAfterSlider";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import MobileStickyBar from "@/components/MobileStickyBar";
import Seo, { businessSchema } from "@/components/seo/Seo";

export default function RealisationsPage() {
  return (
    <div className="min-h-screen bg-[#0284FC]">
      <Seo
        title="Avant / après covering cuisine | Réalisations Vinylux"
        description="Découvrez des exemples avant/après de cuisines rénovées par Vinylux avec des revêtements adhésifs professionnels."
        path="/realisations"
        schema={businessSchema}
      />
      <Navigation />
      <main className="pb-20 lg:pb-0">
        <section className="pt-32 lg:pt-[188px] pb-10 bg-[#0284FC] text-center">
          <div className="max-w-4xl mx-auto px-6">
            <div className="inline-flex bg-white/15 text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-6">Réalisations Vinylux</div>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter text-white mb-6">Avant / après de rénovations de cuisine</h1>
            <p className="text-lg text-white/75 leading-relaxed">Des transformations réalisées sur des cuisines existantes, avec conservation des éléments compatibles et rénovation des surfaces visibles.</p>
          </div>
        </section>
        <BeforeAfterSlider />
        <ContactSection />
      </main>
      <Footer />
      <MobileStickyBar />
    </div>
  );
}
